import _keyBy from 'lodash/keyBy';

import { CustomFrequencyEnum } from '@/types/schema';

export const CustomEmailDigestFrequency = [
  { value: CustomFrequencyEnum.Day, label: 'Day', pluralLabel: 'Days' },
  { value: CustomFrequencyEnum.Week, label: 'Week', pluralLabel: 'Weeks' },
  { value: CustomFrequencyEnum.Month, label: 'Month', pluralLabel: 'Months' },
  { value: CustomFrequencyEnum.Year, label: 'Year', pluralLabel: 'Years' },
];

export const customEmailDigestsById = _keyBy(CustomEmailDigestFrequency, 'value');
